import client from './swiftypeClient';

export const swiftypeClickMixin = {
    methods: {
        handleClick(type) {
            client.click({
                query: this.query,
                documentId: this.data.id,
                requestId: this.requestId,
                tags: [type],
            });
        },
    },
};
